import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';

const NotificationIndicator = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'warning',
      title: 'Stock Bajo',
      message: 'Producto "Laptop Dell XPS" tiene solo 3 unidades restantes',
      time: '5 min',
      read: false
    },
    {
      id: 2,
      type: 'success',
      title: 'Factura Pagada',
      message: 'Factura #INV-2024-001 ha sido pagada por Cliente ABC',
      time: '15 min',
      read: false
    },
    {
      id: 3,
      type: 'info',
      title: 'Nuevo Presupuesto',
      message: 'Presupuesto #QUO-2024-045 requiere aprobación',
      time: '1 hora',
      read: true
    },
    {
      id: 4,
      type: 'error',
      title: 'Error de Sincronización',
      message: 'Error al sincronizar inventario con sistema externo',
      time: '2 horas',
      read: false
    }
  ]);

  const dropdownRef = useRef(null);
  const unreadCount = notifications.filter(n => !n.read).length;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'warning':
        return { name: 'AlertTriangle', color: 'text-warning' };
      case 'success':
        return { name: 'CheckCircle', color: 'text-success' };
      case 'error':
        return { name: 'AlertCircle', color: 'text-error' };
      case 'info':
      default:
        return { name: 'Info', color: 'text-primary' };
    }
  };

  const handleNotificationClick = (notificationId) => {
    setNotifications(prev => 
      prev.map(n => 
        n.id === notificationId ? { ...n, read: true } : n
      )
    );
    console.log('Navigate to notification details:', notificationId);
  };

  const markAllAsRead = () => {
    setNotifications(prev => 
      prev.map(n => ({ ...n, read: true }))
    );
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Notification Button */}
      <button
        onClick={toggleDropdown}
        className="relative p-2 rounded-md hover:bg-secondary-50 transition-micro focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      >
        <Icon name="Bell" size={20} className="text-text-secondary" />
        
        {/* Badge */}
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs font-body-medium rounded-full h-5 w-5 flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown Panel */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-80 bg-surface rounded-lg shadow-modal border border-border z-notification">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 border-b border-border">
            <h3 className="text-sm font-body-medium text-text-primary">
              Notificaciones
            </h3>
            {unreadCount > 0 && (
              <button
                onClick={markAllAsRead}
                className="text-xs text-primary hover:text-primary-700 font-body-medium transition-micro"
              >
                Marcar todas como leídas
              </button>
            )}
          </div>

          {/* Notifications List */}
          <div className="max-h-96 overflow-y-auto">
            {notifications.length === 0 ? (
              <div className="px-4 py-8 text-center">
                <Icon name="Bell" size={32} className="text-text-muted mx-auto mb-2" />
                <p className="text-sm text-text-muted">No hay notificaciones</p>
              </div>
            ) : (
              <div className="py-2">
                {notifications.map((notification) => {
                  const iconConfig = getNotificationIcon(notification.type);
                  return (
                    <button
                      key={notification.id}
                      onClick={() => handleNotificationClick(notification.id)}
                      className={`w-full px-4 py-3 text-left hover:bg-secondary-50 transition-micro border-l-4 ${
                        notification.read 
                          ? 'border-l-transparent' :'border-l-primary bg-primary-50/30'
                      }`}
                    >
                      <div className="flex items-start space-x-3">
                        <div className={`mt-0.5 ${iconConfig.color}`}>
                          <Icon name={iconConfig.name} size={16} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center justify-between">
                            <p className={`text-sm font-body-medium ${
                              notification.read ? 'text-text-secondary' : 'text-text-primary'
                            }`}>
                              {notification.title}
                            </p>
                            <span className="text-xs text-text-muted ml-2">
                              {notification.time}
                            </span>
                          </div>
                          <p className="text-xs text-text-muted mt-1 line-clamp-2">
                            {notification.message}
                          </p>
                        </div>
                        {!notification.read && (
                          <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                        )}
                      </div>
                    </button>
                  );
                })}
              </div>
            )}
          </div>

          {/* Footer */}
          {notifications.length > 0 && (
            <div className="px-4 py-3 border-t border-border">
              <button
                onClick={() => {
                  setIsOpen(false);
                  console.log('Navigate to all notifications');
                }}
                className="w-full text-center text-sm text-primary hover:text-primary-700 font-body-medium transition-micro"
              >
                Ver todas las notificaciones
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationIndicator;